import React from "react";
import "../PageHeadings/PageHeadings.css";

const PageHeadings = ({ showContribute }) => {
  const isDashboard = window.location.pathname === "/dashboard";
  const isViewDetails = window.location.pathname === "/DetailsView";

  return (
    <div className="main-for-headings">
      {isDashboard ? (
        <>
          <h2 className="heading-texts">
            Search athletes to support with contributions and NIL opportunities
          </h2>
        </>
      ) : isViewDetails ? (
        <>
          <div>
            <h2 className="heading-texts-view-detail">
              View <span>Player Details</span>
            </h2>
            <p className="details-page-discription">
              Donate NIL Levels the Playing Field by Connecting Athletes,
              Schools, and Communities for
              <br />
              Sustainable and Transparent Financial Support.
            </p>
          </div>
        </>
      ) : (
        <>
          {showContribute ? (
            <h2 className="heading-texts">
              Collaborate with Athletes and Start Your Fan Experience Today
            </h2>
          ) : (
            <h2 className="heading-texts">
              Collaborate with Athletes and Start Your Brand Partnership Today
            </h2>
          )}
        </>
      )}
    </div>
  );
};

export default PageHeadings;
